import AreaBasic from './area-basic'
import AreaDetailed from './area-detailed'
import BreakpointAmount from './breakpoint-amount'
import BreakpointBasic from './breakpoint-basic'
import BreakpointDetailed from './breakpoint-detailed'
import DeleteConfirmation from "components/modal/delete-confirmation"
import FreeRentBasic  from './free-rent-basic'
import FreeRentDetailed  from './free-rent-detailed'
import FreeRentNamedItem  from './free-rent-named-item'
import LcBasic from './lc-basic'
import LcDetailed from './lc-detailed'
import LcNamedItem from './lc-named-item'
import MiscRevenueBasic from './misc-revenue-basic'
import MiscRevenueDetailed from './misc-revenue-detailed'
import OcBasic from './oc-basic'
import OcNamedItem from './oc-named-item'
import OcDetailed from './oc-detailed'
import OverageBasic from './overage-basic'
import OverageTiered from './overage-tiered'
import Overrides from './overrides'
import RentBasic  from './rent-basic'
import RentDetailed  from './rent-detailed'
import RentNamedItem  from './rent-named-item'
import SalesBasic from './sales-basic'
import SalesDetailed from './sales-detailed'
import SalesInherit from './sales-inherit'
import TiBasic from './ti-basic'
import TINamedItem from './ti-named-item'
import TIDetailed from './ti-detailed'

export default {
  AreaBasic,
  AreaDetailed,
  BreakpointAmount,
  BreakpointBasic,
  BreakpointDetailed,
  DeleteConfirmation,
  FreeRentBasic,
  FreeRentDetailed,
  FreeRentNamedItem,
  LcBasic,
  LcDetailed,
  LcNamedItem,
  MiscRevenueBasic,
  MiscRevenueDetailed,
  OcBasic,
  OcNamedItem,
  OcDetailed,
  OverageBasic,
  OverageTiered,
  Overrides,
  RentBasic,
  RentDetailed,
  RentNamedItem,
  SalesBasic,
  SalesDetailed,
  SalesInherit,
  TiBasic,
  TINamedItem,
  TIDetailed
}
